/*** IMPORTS FROM imports-loader ***/
(function() {
var define = false;

'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _Promise = require('babel-runtime/core-js/promise')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _srcSettings = require('../../../src/settings');

var _srcSettings2 = _interopRequireDefault(_srcSettings);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _reduxModulesAbout = require('redux/modules/about');

var _reactStripeCheckout = require('react-stripe-checkout');

var _reactStripeCheckout2 = _interopRequireDefault(_reactStripeCheckout);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var membershipPlans = [{
	description: 'Fresh Look: $5.00 USD monthly',
	planID: 'fresh_look',
	price: 500
}, {
	description: 'Sharp Eyes: $10 USD monthly',
	planID: 'sharp_eyes',
	price: 1000
}, {
	description: 'Newshound: $15 USD monthly',
	planID: 'newshound',
	price: 1500
}, {
	description: 'Shining Light: $25 USD monthly',
	planID: 'shining_light',
	price: 2500
}, {
	description: 'Truth Seeker: $50 USD monthly',
	planID: 'truth_seeker',
	price: 5000
}, {
	description: 'People’s Mogul: $100 USD monthly',
	planID: 'peoples_mogul',
	price: 10000
}];

var Membership = (function (_Component) {
	_inherits(Membership, _Component);

	function Membership() {
		var _this = this;

		_classCallCheck(this, _Membership);

		_Component.apply(this, arguments);

		this.state = {
			selectorOpen: false,
			selectedSubscription: membershipPlans[0]
		};

		this.onToken = function (token) {
			var planID = _this.state.selectedSubscription.planID;
			_jquery2['default'].ajax({
				url: _srcSettings2['default'].cdn + 'subscribe/index.php',
				method: 'POST',
				data: {
					stripeToken: token.id,
					stripeEmail: token.email,
					stripeSubscription: planID
				}
			}).done(function (data) {
				console.log('Done.', data);
			}).fail(function (data) {
				console.warning('Error:', data);
			});
		};
	}

	Membership.prototype.setSubscription = function setSubscription(sub) {
		this.setState({
			selectorOpen: false,
			selectedSubscription: sub
		});
	};

	Membership.fetchData = function fetchData(getState, dispatch) {
		var promises = [];

		if (!_reduxModulesAbout.isLoaded(getState())) {
			promises.push(dispatch(_reduxModulesAbout.load()));
		}

		return _Promise.all(promises);
	};

	Membership.prototype.render = function render() {
		var _classNames,
		    _this2 = this;

		var _props = this.props;
		var isSmallViewport = _props.isSmallViewport;
		var isMediumViewport = _props.isMediumViewport;

		var styles = require('./Membership.css');
		var contentStyles = _classnames2['default']((_classNames = {}, _classNames[styles['Content--main']] = true, _classNames.CMSContent = true, _classNames));

		return _react2['default'].createElement(
			'main',
			{ className: styles.Base },
			_react2['default'].createElement(_reactHelmet2['default'], { title: 'Membership | Baltimore Brew' }),
			_react2['default'].createElement(
				'article',
				{ className: styles.Article },
				_react2['default'].createElement(
					'header',
					{ className: styles.Header },
					_react2['default'].createElement(
						'h1',
						null,
						'Keep Independent Watchdog Reporting Alive in Baltimore'
					)
				),
				_react2['default'].createElement(
					'div',
					{ className: styles.Content },
					_react2['default'].createElement(
						'article',
						{ className: contentStyles },
						_react2['default'].createElement(
							'h3',
							{ className: 'h3--withBorder' },
							_react2['default'].createElement(
								'u',
								null,
								'Become a Member of Baltimore Brew'
							)
						),
						_react2['default'].createElement(
							'p',
							null,
							'This great accountability journalism doesn’t write itself! It takes hours of hard work by seasoned professional reporters and editors.'
						),
						_react2['default'].createElement(
							'p',
							null,
							'We need your financial support - foundation support does not cover it all.'
						),
						_react2['default'].createElement(
							'p',
							null,
							'Your reader dollars - as well as your clicks and thoughtful online comments - do something even more important, we think.'
						),
						_react2['default'].createElement(
							'p',
							null,
							'They show government and corporate entities that people in Baltimore stand behind ',
							_react2['default'].createElement(
								'em',
								null,
								'The Brew'
							),
							', that you value watchdog journalism, that you want our questions answered on your behalf.'
						),
						_react2['default'].createElement(
							'figure',
							{ className: 'wp-caption--inline' },
							_react2['default'].createElement('img', { src: _srcSettings2['default'].cdn + '/content/uploads/support/marchers.jpg' })
						),
						isSmallViewport ? _react2['default'].createElement(
							'section',
							{ className: styles.Pullquotes },
							_react2['default'].createElement(
								'blockquote',
								{ className: styles.Blockquote },
								_react2['default'].createElement(
									'p',
									null,
									'Baltimore Brew pretty much single-handedly saved Balto taxpayers $100m, looks like. thanks, guys.'
								),
								_react2['default'].createElement(
									'cite',
									null,
									'—Edward Ericson, City Paper'
								)
							)
						) : null,
						isMediumViewport ? _react2['default'].createElement(
							'section',
							{ className: styles.Pullquotes },
							_react2['default'].createElement(
								'blockquote',
								{ className: styles.Blockquote },
								_react2['default'].createElement(
									'p',
									null,
									'Baltimore Brew pretty much single-handedly saved Balto taxpayers $100m, looks like. thanks, guys.'
								),
								_react2['default'].createElement(
									'cite',
									null,
									'—Edward Ericson, City Paper'
								)
							),
							_react2['default'].createElement(
								'blockquote',
								{ className: styles.Blockquote },
								_react2['default'].createElement(
									'p',
									null,
									'Thank God for Baltimore Brew and its reporters. If it weren’t for you folks we’d have no idea what’s really going on in this town.'
								),
								_react2['default'].createElement(
									'cite',
									null,
									'—Bryce Butler'
								)
							)
						) : null,
						_react2['default'].createElement(
							'h3',
							{ className: 'h3--withBorder' },
							_react2['default'].createElement(
								'u',
								null,
								'Membership Levels'
							)
						),
						_react2['default'].createElement(
							'ul',
							{ className: 'PriceList' },
							_react2['default'].createElement(
								'li',
								null,
								_react2['default'].createElement(
									'span',
									{ className: 'light' },
									'$5'
								),
								' Fresh Look'
							),
							_react2['default'].createElement(
								'li',
								null,
								_react2['default'].createElement(
									'span',
									{ className: 'light' },
									'$10'
								),
								' Sharp Eyes'
							),
							_react2['default'].createElement(
								'li',
								null,
								_react2['default'].createElement(
									'span',
									{ className: 'light' },
									'$15'
								),
								' Newshound'
							),
							_react2['default'].createElement(
								'li',
								null,
								_react2['default'].createElement(
									'span',
									{ className: 'light' },
									'$25'
								),
								' Shining Light'
							),
							_react2['default'].createElement(
								'li',
								null,
								_react2['default'].createElement(
									'span',
									{ className: 'light' },
									'$50'
								),
								' Truth Seeker'
							),
							_react2['default'].createElement(
								'li',
								null,
								_react2['default'].createElement(
									'span',
									{ className: 'light' },
									'$100'
								),
								' People’s Mogul'
							)
						),
						_react2['default'].createElement(
							'section',
							{ className: styles.Subscribe },
							_react2['default'].createElement(
								'div',
								{ className: styles.SubscriptionSelect },
								_react2['default'].createElement(
									'div',
									{ className: styles.Selector },
									_react2['default'].createElement(
										'div',
										{ className: styles.SelectorLabel, onClick: function () {
												_this2.setState({ selectorOpen: !_this2.state.selectorOpen });
											} },
										this.state.selectedSubscription.description
									),
									this.state.selectorOpen ? _react2['default'].createElement(
										'ul',
										{ className: styles.SelectorItems },
										membershipPlans.map(function (plan, index) {
											return _react2['default'].createElement(
												'li',
												{ key: 'Plan_' + index, onClick: _this2.setSubscription.bind(_this2, plan) },
												plan.description
											);
										})
									) : null
								),
								_react2['default'].createElement(
									_reactStripeCheckout2['default'],
									{
										allowRememberMe: true,
										amount: this.state.selectedSubscription.price,
										className: styles.Button,
										componentClass: 'button',
										currency: 'USD',
										description: this.state.selectedSubscription.description,
										image: '//content.baltimorebrew.com/content/uploads/b.png',
										locale: 'auto',
										name: 'Baltimore Brew',
										panelLabel: 'Charge',
										stripeKey: 'pk_BUALd2oHIghEfQtUiOuJ2c9phgxs6',
										token: this.onToken,
										zipCode: true
									},
									'Subscribe'
								)
							)
						),
						_react2['default'].createElement(
							'figure',
							{ className: 'wp-caption--inline' },
							_react2['default'].createElement('img', { src: _srcSettings2['default'].cdn + '/content/uploads/support/fern-photo.jpg' })
						),
						isSmallViewport ? _react2['default'].createElement(
							'section',
							{ className: styles.Pullquotes },
							_react2['default'].createElement(
								'blockquote',
								{ className: styles.Blockquote },
								_react2['default'].createElement(
									'p',
									null,
									'Thank God for Baltimore Brew and its reporters. If it weren’t for you folks we’d have no idea what’s really going on in this town.'
								),
								_react2['default'].createElement(
									'cite',
									null,
									'—Bryce Butler'
								)
							)
						) : null,
						_react2['default'].createElement(
							'p',
							null,
							'You can also make a one-time contribution to support The Brew by check. ',
							_react2['default'].createElement(
								'em',
								{ className: 'light' },
								_react2['default'].createElement(
									'strong',
									null,
									'Please make your check out to "MDDC Press Foundation" with "Baltimore Brew" in the notation line'
								),
								' at the bottom left.'
							)
						),
						_react2['default'].createElement(
							'p',
							null,
							'We are happy to say the Maryland Delaware DC MDDC Press Foundation is now our fiscal sponsor, allowing us to accept tax-free donations.'
						),
						_react2['default'].createElement(
							'p',
							null,
							'All support sent to us through the MDDC Press Foundation, whether monthly or one-time, is 100 percent tax-deductible.'
						),
						_react2['default'].createElement(
							'p',
							null,
							'(Fusion Partnerships is no longer serving as The Brew’s fiscal sponsor. They announced in early 2025 they are discontinuing that service to all partner groups.)'
						),
						_react2['default'].createElement(
							'p',
							{ className: 'address' },
							_react2['default'].createElement(
								'span',
								{ className: 'address' },
								'Checks should be sent to:',
								_react2['default'].createElement('br', null),
								_react2['default'].createElement(
									'em',
									{ className: 'light' },
									'MDDC Press Foundation',
									_react2['default'].createElement('br', null),
									'P.O. Box 26214',
									_react2['default'].createElement('br', null),
									'Baltimore, MD 21210'
								)
							)
						),
						_react2['default'].createElement(
							'h3',
							null,
							'That’s it! With affection and gratitude for all our readers old and new,'
						),
						_react2['default'].createElement(
							'p',
							{ className: 'p--centered' },
							'Fern Shen, Mark Reutter and the rest of ',
							_react2['default'].createElement(
								'em',
								null,
								'The Brew'
							),
							' Team.'
						)
					),
					!isSmallViewport && !isMediumViewport ? _react2['default'].createElement(
						'aside',
						{ className: styles['Content--sidebar'] },
						_react2['default'].createElement(
							'blockquote',
							{ className: styles.Blockquote },
							_react2['default'].createElement(
								'p',
								null,
								'Baltimore Brew pretty much single-handedly saved Balto taxpayers $100m, looks like. thanks, guys.'
							),
							_react2['default'].createElement(
								'cite',
								null,
								'—Edward Ericson, City Paper'
							)
						),
						_react2['default'].createElement(
							'blockquote',
							{ className: styles.Blockquote },
							_react2['default'].createElement(
								'p',
								null,
								'Thank God for Baltimore Brew and its reporters. If it weren’t for you folks we’d have no idea what’s really going on in this town.'
							),
							_react2['default'].createElement(
								'cite',
								null,
								'—Bryce Butler'
							)
						)
					) : null
				)
			)
		);
	};

	_createClass(Membership, null, [{
		key: 'propTypes',
		value: {
			about: _react.PropTypes.object,
			aboutError: _react.PropTypes.string,
			aboutLoading: _react.PropTypes.bool,
			isSmallViewport: _react.PropTypes.bool,
			isMediumViewport: _react.PropTypes.bool,
			location: _react.PropTypes.object
		},
		enumerable: true
	}]);

	var _Membership = Membership;
	Membership = _reactRedux.connect(function (state) {
		return {
			about: state.about.data,
			aboutError: state.about.error,
			aboutLoading: state.about.loading,
			isSmallViewport: state.responsive.isSmallViewport,
			isMediumViewport: state.responsive.isMediumViewport
		};
	})(Membership) || Membership;
	return Membership;
})(_react.Component);

exports['default'] = Membership;
module.exports = exports['default'];
}.call(window));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Membership/Membership.js
 ** module id = 704
 ** module chunks = 0
 **/